export default __webpack_public_path__ + "static/media/CZ-RTC6BLW 2.f722a6d0.jpg";